import { AffiliateContext, AffiliateContextData } from "@contexts/affiliate/AffiliateContext";
import { useContext } from "react";

interface UseAffiliateDataReturn {
  data?: AffiliateContextData["data"];
  isLoading: boolean;
  isError: boolean;
  acceptAffiliation: () => void;
}

export const affiliationLocalStorageKey = "AF";
export const affiliationAutomaticAffiliateEnabled = "AF-automaticAffiliateEnabled";

export function useAffiliateData(): UseAffiliateDataReturn {
  const { data, isLoading, isError, productUuid } = useContext(AffiliateContext);

  const acceptAffiliation = () => {
    localStorage.setItem(affiliationLocalStorageKey, productUuid);
    localStorage.setItem(
      affiliationAutomaticAffiliateEnabled,
      data?.productAffiliateSettings?.automaticAffiliateEnabled ? "1" : "0"
    );
    const affiliationRequestDate = new Date().toISOString();
    localStorage.setItem(productUuid, affiliationRequestDate);
  };

  return {
    data,
    isLoading,
    isError,
    acceptAffiliation,
  };
}
